export default {
  rootPath: () => '/',

  surveyPath: () => '/mortgages/mortgage-rates',
  surveyPathEmbed: () => '/mortgages/mortgage-rates/embed',
  calculatorPathEmbed: () => '/mortgages/mortgage-calculators/embed',
  todaysRatesPath: () => '/mortgages/todays-mortgage-rates',
  quizPath: () => '/mortgages/how-much-house-can-i-afford/quiz',
  calculatorsPath: () => '/mortgages/mortgage-calculators',
  termsPath: () => '/terms',
  privacyPath: () => '/privacy',
  faqsPath: () => '/faqs',
  aboutUsPath: () => '/about-us',
  paymentBudgetPath: () => '/mortgages/monthly-payment-budget',

  loanOfficerSearchSurveyRootPath: () => '/mortgages/mortgage-rates/loan-officer-search',
  loanOfficerSearchSurveyListPath: () => '/mortgages/mortgage-rates/loan-officer-search/list',
  loanOfficersSearchSurveyWizardPath: () => `/mortgages/mortgage-rates/loan-officer-search/wizard`,

  loanOfficerFindRealEstateAgents: () => '/loan-officer/find-real-estate-agents',

  dashboardPath: () => '/dashboard',
  messagesPath: () => '/messages',
  settingsPath: () => '/account-settings',

  loginPath: () => '/login',
  signUpPath: () => '/signup',
  forgotPasswordPath: () => '/forgot-password',
  resetPasswordPath: () => '/reset-password',
  emailConfirmedPath: () => '/email-confirmed',

  adminRootPath: () => '/admin',
  adminLoanOfficerPath: id => `/admin/loan-officer/${id}`,

  loanOfficerPath: () => '/loan-officer',
  realEstateAgentPath: () => '/real-estate-agent',
  loanOfficersPath: () => '/loan-officers',
  referralRealEstateAgentPath: slug => `/referral/${slug}`,
};



// WEBPACK FOOTER //
// ./src/routes/appRoutes.js